// ...existing imports...
import React, { useState, useEffect, useMemo, useRef } from "react";
import "./style.css";
import { internshipRequestsList, internshipQualifications } from "../user.api";
import Loader from "../../../components/loader/loader";
import { Toast } from "bootstrap";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import jwtDecode from "jwt-decode";
import BreadCrumpBack from "../../../components/navigator/back";

if (typeof process === 'undefined') {
  window.process = { env: {} };
}

let PageSize = 9;

export default function InternshipProposalsList(props) {
  const userPayload = props.state.payload ? jwtDecode(props.state.payload) : {};
  const isSubUser =
    userPayload?.actor === "company_user" ||
    userPayload?.user?.is_company_user ||
    userPayload?.is_company_user;
  const isPublicRoute = props.location.pathname.startsWith("/public");
  const [isActive, setIsActive] = useState(false);
  const myRef = useRef(null);
  const [searchData, setSearchData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [qualifications, setQualifications] = useState([]);
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const servInstance = process.env.REACT_APP_BASE_URL || "";
  let result = servInstance ? servInstance.substring(0, servInstance?.length - 4) : "";

  const listData = (page = 1) => {
    setIsActive(true);
    internshipRequestsList(isPublicRoute, { page })
      .then((res) => {
        setSearchData(res?.data || []);
        setPagination(res?.pagination || null);
        setIsActive(false);
      })
      .catch((err) => {
        setIsActive(false);
        Toast.error("Something Went Wrong");
      });
  };

  const mainData = useMemo(() => {
    return searchData;
  }, [searchData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    listData(page);
    myRef.current.scrollIntoView();
  };

  useEffect(() => {
    listData(currentPage);
  }, [isPublicRoute]);

  useEffect(() => {
    internshipQualifications()
      .then((res) => {
        setQualifications(res?.data || []);
      })
      .catch((err) => {
        setQualifications([]);
      });
  }, []);

  const handleCreateNew = () => {
    props.history.push("/internship-proposals-form");
  };

  const handleViewDetails = (id) => {
    const basePath = isPublicRoute ? "/public-internship-proposals" : "/internship-proposals";
    props.history.push(`${basePath}/${id}`);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "Pending";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      default:
        return status || "Unknown";
    }
  };

  const getQualificationName = (id) => {
    const findQual = (items, id) => {
      for (let item of items) {
        if (item.id === id) return item.name;
        if (item.children_recursive) {
          const found = findQual(item.children_recursive, id);
          if (found) return found;
        }
      }
      return null;
    };
    return findQual(qualifications, id);
  };

  return (
    <div className="tender bg-tender" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "ഇന്റേൺഷിപ്പ് പ്രൊപ്പോസലുകൾ"
              : "Internship Proposals"}
          </div>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container p-50">
        <div className="res-page-cont">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5>
              {props.state.language === "ma"
                ? "സമർപ്പിച്ച ഇന്റേൺഷിപ്പ് പ്രൊപ്പോസലുകൾ"
                : "Internship Proposals"}
            </h5>
            {!isSubUser && !isPublicRoute && (
              <button
                className="btn btn-primary"
                onClick={handleCreateNew}
              >
                {props.state.language === "ma"
                  ? "+ പുതിയ പ്രൊപ്പോസൽ"
                  : "+ Create New Proposal"}
              </button>
            )}
          </div>

          {pagination && (
            <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm border">
              <div className="text-muted" style={{ fontSize: '13px' }}>
                Showing <span className="font-weight-bold text-dark">{pagination.from || 0}</span> to <span className="font-weight-bold text-dark">{pagination.to || 0}</span> of <span className="font-weight-bold text-dark">{pagination.total || 0}</span> proposals
              </div>
              <div className="text-muted" style={{ fontSize: '13px' }}>
                Page <span className="font-weight-bold text-dark">{pagination.current_page}</span> of <span className="font-weight-bold text-dark">{pagination.last_page}</span>
              </div>
            </div>
          )}

          {mainData && mainData.length > 0 ? (
            <>
              <div className="row">
                {mainData.map((item, index) => (
                  <div key={index} className="col-md-4 col-sm-6 mb-4">
                    <div className="card internship-card h-100 shadow-sm border-0" style={{ transition: 'transform .2s' }}>
                      <div className="card-body d-flex flex-column p-4">
                        <div className="flex-grow-1">
                          {isPublicRoute && (
                            <div className="company-info d-flex align-items-center mb-3">
                              {item.company?.logo ? (
                                <img
                                  src={result + item.company.logo}
                                  alt="Logo"
                                  className="company-logo-sm me-2 rounded"
                                  style={{ width: '28px', height: '28px', objectFit: 'contain' }}
                                />
                              ) : (
                                <div className="company-logo-placeholder me-2 d-flex align-items-center justify-content-center bg-light text-muted small" style={{ width: '28px', height: '28px', borderRadius: '4px' }}>
                                  <i className="fa fa-building"></i>
                                </div>
                              )}
                              <span className="text-primary font-weight-bold" style={{ fontSize: '0.85rem' }}>{item.company?.company_name}</span>
                            </div>
                          )}
                          <h5 className="card-title text-dark font-weight-bold mb-1">
                            {item.internship_discipline || "N/A"}
                          </h5>

                          <p className="card-text text-muted mb-4 pb-2" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
                            {item.brief_description?.length > 100
                              ? item.brief_description.substring(0, 100) + "..."
                              : item.brief_description}
                          </p>

                          <div className="internship-meta border-0 p-0 m-0">
                            <div className="mb-2">
                              <div className="text-muted small mb-2 font-weight-bold" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Course Completion Status</div>
                              <div className="d-flex gap-4">
                                <span className="small d-flex align-items-center text-dark">
                                  {(item.target_category === 'students_undergoing_course' || item.target_category === 'both') ? (
                                    <i className="fa fa-check-circle text-success me-2" style={{ fontSize: '14px' }}></i>
                                  ) : (
                                    <i className="fa fa-times-circle text-danger me-2" style={{ fontSize: '14px' }}></i>
                                  )}
                                  Undergoing
                                </span>
                                <span className="small d-flex align-items-center text-dark">
                                  {(item.target_category === 'completed' || item.target_category === 'both') ? (
                                    <i className="fa fa-check-circle text-success me-2" style={{ fontSize: '14px' }}></i>
                                  ) : (
                                    <i className="fa fa-times-circle text-danger me-2" style={{ fontSize: '14px' }}></i>
                                  )}
                                  Completed
                                </span>
                              </div>
                            </div>

                            <div className="mb-2">
                              <span className="badge bg-white text-dark border px-3 py-2" style={{ borderRadius: '20px', fontSize: '11px', fontWeight: '500', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                <i className="fa fa-user-circle me-1 text-primary"></i>
                                {item.number_of_students || "0"} Positions
                              </span>
                            </div>

                            <div className="mb-2">
                              <div className="d-flex align-items-center bg-light p-3 rounded" style={{ fontSize: '12px', border: '1px dashed #dee2e6' }}>
                                <i className="fa fa-calendar-check-o me-3 text-primary" style={{ fontSize: '18px' }}></i>
                                <div>
                                  <div className="text-muted mb-1" style={{ fontSize: '10px', textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '0.3px' }}>Internship Period</div>
                                  <div className="font-weight-bold text-dark" style={{ fontSize: '13px' }}>
                                    {formatDate(item.preferred_start_date)} - {formatDate(item.preferred_end_date)}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {!isPublicRoute && (
                              <div className="mb-2">
                                <span className={`badge badge-${getStatusBadgeClass(item.status)} px-2 py-1`}>
                                  STATUS - {getStatusText(item.status)}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {(!isSubUser || isPublicRoute) && (
                          <button
                            className="btn btn-primary mt-auto w-100 py-2 font-weight-bold"
                            style={{ borderRadius: '6px', fontSize: '14px', backgroundColor: '#1a233a', borderColor: '#1a233a' }}
                            onClick={() => handleViewDetails(item.id)}
                          >
                            {props.state.language === "ma"
                              ? "വിശദാംശങ്ങൾ വിുചരിക്കുക"
                              : "View Details"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {pagination && pagination.last_page > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination
                    currentPage={pagination.current_page}
                    totalCount={pagination.total}
                    pageSize={pagination.per_page}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="alert alert-info text-center">
              {props.state.language === "ma"
                ? "യാതൊരു ഇന്റേൺഷിപ്പ് പ്രൊപ്പോസലും സമർപ്പിക്കപ്പെട്ടിട്ടില്ല"
                : "No internship proposals found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
